module.exports = __webpack_public_path__ + "static/media/Home Warranty.8c92ceab.svg";